import values from 'lowscore/values.js'
import compact from 'lowscore/compact.js'
import parseDate from '../../../../packages/dates/parse.js'
import stringFormat from 'root-core/utils/text/stringFormatFilter.js'

export default class ReturnValidationRules {
  constructor (rootModel, model) {
    this.model = model
    var errorMessages = rootModel.config.errorMessages
    var departure = rootModel.departure
    var dateFormat = rootModel.config.dateFormat
    this.config = rootModel.config

    function setError (name, error) {
      model.validationErrors = model.validationErrors || {}
      model.validationErrors[name] = error
    }

    this.rules = {
      departureAirport (e) {
        var error
        var shouldValidate = !e || !e.target.getAttribute('autoCompleteOpen')
        if (
          shouldValidate &&
          rootModel.allAirports.indexOf(model.departureAirport) === -1
        ) {
          error = errorMessages.flightDepartureAirport
        }
        setError('departureAirport', error)
      },

      departureDate () {
        let startDate = departure.startDate.addDays(
          -1 * rootModel.quoteCriteria.hotelsBefore.selectedNights.number
        )

        const today = new Date()
        var error = null
        if (model.departureDate) {
          const flightDate = parseDate(model.departureDate, dateFormat)
          if (!flightDate) {
            error = stringFormat(errorMessages.dateFormat, dateFormat)
          } else if (flightDate > startDate) {
            error = errorMessages.flightDepartureDate
          } else if (today > flightDate) {
            error = errorMessages.flightDepartureDateInPast
          }
        } else {
          error = stringFormat(errorMessages.required, 'departure date')
        }

        setError('departureDate', error)
      },

      returnDate () {
        let endDate = departure.endDate.addDays(
          rootModel.quoteCriteria.hotelsAfter.selectedNights.number
        )

        var error = null
        if (model.returnDate) {
          var date = parseDate(model.returnDate, dateFormat)
          if (date) {
            if (endDate.toString() > model.returnDate) {
              error = errorMessages.flightReturnDate
            }
          } else {
            error = stringFormat(errorMessages.dateFormat, dateFormat)
          }
        } else {
          error = stringFormat(errorMessages.required, 'return date')
        }

        setError('returnDate', error)
      },

      tripNotesRead () {
        var error = null
        if (!model.tripNotesRead) {
          error = errorMessages.flightsTripNotesRead
        }
        setError('tripNotesRead', error)
      },
    }
  }

  validate () {
    var requiredRules = ['departureAirport', 'departureDate', 'returnDate']
    if (this.config.flights.requireTripNotesRead) {
      requiredRules.push('tripNotesRead')
    }
    this.model.validationErrors = {}

    requiredRules.forEach(key => {
      this.rules[key]()
    })

    return compact(values(this.model.validationErrors)).length == 0
  }
}
